// Unified shadow and glow tokens for glassmorphism and premium effects

export const SHADOWS = {
  glass: {
     // emerald glow
    
    
    
    },
  card: {
    
    
    
    
    },
  glow: {
     // gold glow
    
    
    
    }
};

export const BLUR = {
  glass: 24, // for glassy backgrounds
};
